const BookingValidation = () => {
  return {
    fields: [
      {
        name: "title",
        validates: "required",
      },
      {
        name: "firstName",
        validates: "required",
      },
      {
        name: "lastName",
        validates: "required",
      },
      {
        name: "email",
        validates: "required|email",
      },
      {
        name: "country",
        validates: "required",
      },
      {
        name: "nationality",
        validates: "required",
      },
      {
        name: "phoneCode",
        validates: "required",
      },
      {
        name: "phone",
        validates: "required",
      },
      {
        name: "birthday",
        validates: "required",
      },
      {
        name: "passport",
        validates: "required",
      },
      {
        name: "signature",
        validates: "required",
      },
      {
        name: "terms",
        validates: "required",
      },
      {
        name: "dateOfExpiry",
        validates: "required",
      },
      {
        name: "document",
        validates: "required",
      },
    ],
    steps: [
      ["title", "firstName", "lastName", "email"],
      ["country", "nationality", "phoneCode", "phone", "birthday", "terms"],
      ["passport", "signature", "document"],
    ],
    collection: [
      "title",
      "firstName",
      "lastName",
      "email",
      "nationality",
      "phoneCode",
      "phone",
      "terms",
      "signature",
    ],
  };
};

export default BookingValidation;
